import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { resolveGroupLandingRoute } from "../../shared/utils/group-landing.util";
import { AuthService } from "../auth/auth.service";

/** Sends `/` to the first landing route allowed by the user's groups. */
export const groupLandingGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const target = resolveGroupLandingRoute(
    (group) => authService.hasAnyGroup([group]),
    undefined,
    (role) => authService.hasRole(role),
  );
  return router.parseUrl(target);
};
